export default {
  SET_ATTENDEES(state, payload) {
    state.attendeesData = payload;
  },
};
